import React from 'react';
import { Switch as ReactRouterSwitch, Route, Redirect } from 'react-router';
import { PageHeadline, PageContent, PageMain } from '../Typo/Typo';
import { useCurrentAliceApp } from '../../hooks/useCurrentAliceApp';
import { useSharingPageMenuItems } from '../../hooks/useSharingPageMenuItems';
import Menu from '../Menu/Menu';
import i18n from '@yandex-int/i18n';
import * as keyset from 'i18n/Access';
import { routes } from '../../lib/routes';
import { UsersPage } from './UsersPage/UsersPage';
import { LinksPage } from './LinksPage/LinksPage';
import { SkillAccess } from '../../model/settings';
import { ErrorBoundary } from '../ErrorBoundary/ErrorBoundary';

const t = i18n(keyset);

export const SharingPage: React.FC = () => {
    const skill = useCurrentAliceApp()!;
    const { menuItems, display } = useSharingPageMenuItems(skill);

    if (!skill.onAir || skill.skillAccess !== SkillAccess.Private) {
        return (
            <div>
                <PageHeadline title={t('header')} />
                <div>{t('error-only-private')}</div>
            </div>
        );
    }

    return (
        <ErrorBoundary withHomepageLink>
            <div>
                <PageHeadline title={t('header')} />
                <Menu items={menuItems} />
                <PageContent>
                    <PageMain>
                        <ReactRouterSwitch>
                            {display.main && (
                                <Route path={routes.app.skillPage(false, 'sharing/main', skill.id)}>
                                    {() => <LinksPage />}
                                </Route>
                            )}
                            {display.users && (
                                <Route path={routes.app.skillPage(false, 'sharing/users', skill.id)}>
                                    <UsersPage />
                                </Route>
                            )}
                            <Redirect
                                exact
                                from={routes.app.skillPage(false, 'sharing', skill.id)}
                                to={routes.app.skillPage(false, 'sharing/main', skill.id)}
                            />
                        </ReactRouterSwitch>
                    </PageMain>
                </PageContent>
            </div>
        </ErrorBoundary>
    );
};
